import { render, staticRenderFns } from "./InboxMessage.vue?vue&type=template&id=196250ba"
import script from "./InboxMessage.vue?vue&type=script&lang=ts"
export * from "./InboxMessage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('196250ba')) {
      api.createRecord('196250ba', component.options)
    } else {
      api.reload('196250ba', component.options)
    }
    module.hot.accept("./InboxMessage.vue?vue&type=template&id=196250ba", function () {
      api.rerender('196250ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/InboxMessage.vue"
export default component.exports